import styled, { css } from 'styled-components'

import { Link as LinkBase } from '@application/Interfaces/Atoms/Link'
import { Button as ButtonBase } from '@application/Interfaces/Molecules/Button'
import { ThemeModeType } from '@application/Types/ComponentTypes'

export const Container = styled.div`
    max-width: 990px;
    margin: 0 auto;
    padding-left: 10px;
    padding-right: 10px;
`

export const Title = styled.h3`
    ${(props) => props.theme.typo.displayM};
    ${(props) => props.theme.fontWeight.medium};
    margin-bottom: 10px;
`

export const Description = styled.div`
    ${(props) => props.theme.typo.bodyL};
    ${(props) => props.theme.fontWeight.regular};
`

const portStyle = css`
    ${(props) => props.theme.typo.bodyL};
    ${(props) => props.theme.fontWeight.regular};
    text-decoration: none;
    margin-bottom: 10px;
`

export const PortLink = styled(LinkBase)`
    ${portStyle}

    &:hover {
        text-decoration: underline;
    }
`
export const PortName = styled.span`
    ${portStyle}
`

export const Link = styled(LinkBase)`
    display: inline-block;
    margin-top: 40px;
    clear: both;
`

export const Button = styled(ButtonBase)`
    width: 100%;

    button {
        width: 100%;
    }

    @media ${(props) => props.theme.query.min.tablet} {
        width: auto;
    }
`

export const Wrapper = styled.div<{ $mode: ThemeModeType }>`
    background: ${(props) => props.theme.color[props.$mode === 'Light' ? 'g100' : 'p600']};
    padding: 50px 20px;

    @media ${(props) => props.theme.query.min.tablet} {
        padding: 100px 0;
    }

    ${Title} {
        color: ${(props) => props.theme.color[props.$mode === 'Light' ? 'p500' : 'white']};
    }

    ${Description}, ${PortLink}, ${PortName} {
        color: ${(props) => props.theme.color[props.$mode === 'Light' ? 'g600' : 'g100']};
    }
`
